import { TrackInfo } from './playlist-helpers'
import { funImages, generalBackgroundImages } from './background-images'
import { asType } from './common/type-helpers'

export async function getTracksInfo() {
  const tracksInfo: TrackInfo[] = [
    {
      url: `${process.env.PUBLIC_URL}/tracks/What's This - v7-space-pre.wav`,
      title: "What's This?",
      composer: "Danny Elfman",
    },
    {
      url: `${process.env.PUBLIC_URL}/tracks/Christmastime v5.wav`,
      title: "Christmastime",
      composer: "Billy Corgan (The Smashing Pumpkins)",
    },
    {
      url: `${process.env.PUBLIC_URL}/tracks/All I want for Christmas (Indie Girl) v11-space-pre.wav`,
      title: 'All I Want For Christmas Is You',
      composer: "Mariah Carey and Walter Afanasieff",
    },
    {
      url: `${process.env.PUBLIC_URL}/tracks/I Don't Know What Christmas Is v8.wav`,
      title: "I Don't Know What Christmas Is",
      composer: "Stewart Ransom Miller and James Gunn (The Old 97s)",
    },
    {
      url: `${process.env.PUBLIC_URL}/tracks/Breath of Heaven - Secretina v7.wav`,
      title: "Breath Of Heaven (Mary's Song)",
      composer: "Amy Grant",
      media: {
        excluded: [
          ...funImages,
        ],
      }
    },
    {
      url: `${process.env.PUBLIC_URL}/tracks/Where Are You Christmas v4.wav`,
      title: "Where Are You Christmas?",
      composer: "Mariah Carey, James Horner, and Will Jennings",
    },
    {
      url: `${process.env.PUBLIC_URL}/tracks/Have yourself a merry little Christmas v5.wav`,
      title: "Have Yourself A Merry Little Christmas",
      composer: "Hugh Martin and Ralph Blane",
    },
  ]

  return tracksInfo.map(info => {
    return asType<TrackInfo>({
      ...info,
      media: {
        ...info.media,
        sources: info?.media?.sources || generalBackgroundImages,
      },
    })
  })
}
